import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Pandian from "../pages/pandian/page";
import SeriesDetail from "../pages/series/page";
import Duibi from "../pages/duibi/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pandian",
    element: <Pandian />,
  },
  {
    path: "/shijian/:slug",
    element: <SeriesDetail />,
  },
  {
    path: "/duibi",
    element: <Duibi />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;